import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
  useHearAbout,
  useI18n,
  useProfile,
  useRehabQuestion2,
  useRehabSelectedThemes,
  useUserProfile,
} from 'contexts/AuthContext'
import { Button } from 'antd'
import classnames from 'classnames'
import ContentHeader from 'views/Care/ContentHeader'
import painLow from './img/ic-pain-low.svg'
import painHigh from './img/ic-pain-high.svg'
import classes from './index.module.scss'
import { ScreenKey } from 'views/Care/util'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { logBrazeEvent } from 'utils/brazeInit'
import { rehabCareFlowFinished } from '../util'
import { CareReason } from '../returnTo'
import { updateUserPromise } from 'apis/FitOnCareAPI'
import { getLocalLanguage } from 'utils/authLocalStorage'
import _ from 'lodash'
import { AuthContext } from 'contexts/AuthContext'
const { styles } = classes

const DataList = [
  {
    id: 1,
    title: 'We recommend you consult a healthcare provider.',
    subtitle:
      'Based on your answers, we recommend you consult a healthcare provider for further evaluation.',
    icon: painHigh,
    buttonText: 'Close',
  },
  {
    id: 2,
    title: 'Let’s confirm your insurance.',
    subtitle:
      'Good news! You may be eligible for our Rehab program. Let’s confirm your insurance details to get started.',
    icon: painLow,
    buttonText: 'Continue',
  },
]

const RehabConsultProvider = (props) => {
  const { sku, from, autoLoginSuccess, utmSource, shouldSkipScheduledTime } =
    props
  const { i18n } = useI18n()
  const { rehabQuestion2 } = useRehabQuestion2()
  const { rehabSelectedThemes } = useRehabSelectedThemes()
  const [data, setData] = useState({})
  const { userProfile } = useUserProfile()
  const { profile: healthieProfile } = useProfile()
  const { hearAbout } = useHearAbout()
  const authContext = useContext(AuthContext)
  useEffect(() => {
    props.setRemoveEventListener(true)
  }, [])

  const { theme } = useMemo(() => {
    return {
      theme: rehabSelectedThemes?.map((theme) => theme.name).join(','),
    }
  }, [rehabSelectedThemes])

  useEffect(() => {
    if (rehabQuestion2?.id < 5) {
      setData(DataList[1])
      logAmplitudeEvent('Screen View: Onboarding - Initial Eligibility', {
        sku,
        theme,
        level: rehabQuestion2.id,
        language: getLocalLanguage(),
      })
      logBrazeEvent(`User Eligible - ${sku}`)
      if (userProfile.skuStatus?.[sku] === 5) {
        updateUserPromise(
          {
            skuStatus: {
              sku,
              status: 1,
            },
          },
          authContext
        )
      }
    } else {
      setData(DataList[0])
      switch (sku) {
        case 'pt':
          logAmplitudeEvent('Screen View: Onboarding - Not Available', {
            Reason: 'Condition',
            Detail: 'Pain Level',
            sku,
            language: getLocalLanguage(),
          })
          updateUserPromise(
            {
              skuStatus: {
                sku,
                status: 5,
              },
            },
            authContext
          )
          break
        default:
          logAmplitudeEvent(
            'Screen View: Onboarding - Rehab Consult Provider',
            {
              Reason: 'Condition',
              Detail: 'Pain Level',
              sku,
              theme,
              language: getLocalLanguage(),
            }
          )
          break
      }
      logBrazeEvent(`User Denied: Pain Level - ${sku}`)
    }
  }, [rehabQuestion2, sku, theme])

  const onNext = () => {
    if (rehabQuestion2?.id < 5) {
      switch (sku) {
        case 'pt':
          props.setCurrentKey(ScreenKey.INSURANCE_CARD_INFO)
          break
        default:
          if (autoLoginSuccess) {
            if (userProfile.skuStatus?.msk === 2) {
              if (shouldSkipScheduledTime) {
                props.setCurrentKey(ScreenKey.REHAB_CONGRATULATIONS)
              } else {
                props.setCurrentKey(ScreenKey.SCHEDULED_TIME)
              }
            } else {
              if (healthieProfile.gender) {
                if (!_.isEmpty(hearAbout) || utmSource) {
                  if (userProfile.insuranceProvided) {
                    if (shouldSkipScheduledTime) {
                      props.setCurrentKey(ScreenKey.REHAB_CONGRATULATIONS)
                    } else {
                      props.setCurrentKey(ScreenKey.SCHEDULED_TIME)
                    }
                  } else {
                    props.setCurrentKey(ScreenKey.TALK_ABOUT_COVERAGE)
                  }
                } else {
                  props.setCurrentKey(ScreenKey.HEAR_ABOUT)
                }
              } else {
                props.setCurrentKey(ScreenKey.COMPLETE_PROFILE)
              }
            }
          } else {
            props.setCurrentKey(ScreenKey.PERSONAL_INFO)
          }
      }
    } else {
      rehabCareFlowFinished(false, 0, from, '', sku, CareReason.pain)
    }
  }

  const onBack = (e) => {
    props.setRemoveEventListener(false)
    props.onBack(e)
  }

  return (
    <div className={classnames(styles, 'info-sec')}>
      <ContentHeader {...props} onBack={onBack} />
      <div className='info-content'>
        <img src={data.icon} alt='' className='top-icon' />
        <div className='title'>{i18n(data.title)}</div>
        <div
          className='subtitle'
          style={{ marginBottom: '10px', marginTop: '17px' }}
        >
          {i18n(data.subtitle)}
        </div>
        <div className='bottom-btn'>
          <Button
            className='btn-primary full-width-btn next-btn'
            onClick={onNext}
          >
            {i18n(data.buttonText)}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RehabConsultProvider
